import { EditorState } from 'draft-js';
import moment from 'moment';
import DateHelper, {DATE_TIME_FORMAT} from '../components/helpers/DateHelper';
import {REGULAR_TYPE} from "../components/company/subscriptionType";

export default {
    messages: [],
    user: {
        id: undefined,
        dataIsFetched: false,
        name: '',
        workingTitle: '',
        city: '',
        address: '',
        postalCode: '',
        phone: '',
        mobilePhone: '',
        directPhoneNumber: '',
        email: '',
        regionId: '',
        municipalityId: '',
        addressId: '',
        linkedIn: '',
        company: '',
        role: '',
        isAdmin: false,
    },
    demoAdminUser: null,
    userProfile: {
        id: undefined,
        dataIsFetched: false,
        name: '',
        workingTitle: '',
        city: '',
        address: '',
        postalCode: '',
        phone: '',
        mobilePhone: '',
        directPhoneNumber: '',
        email: '',
        regionId: '',
        municipalityId: '',
        addressId: '',
        linkedIn: '',
        company: '',
        role: '',
        isAdmin: false,
    },
    // not current user
    someUser: {
        id: undefined,
        dataIsFetched: false,
        name: '',
        workingTitle: '',
        city: '',
        address: '',
        postalCode: '',
        phone: '',
        mobilePhone: '',
        directPhoneNumber: '',
        email: '',
        regionId: '',
        municipalityId: '',
        addressId: '',
        linkedIn: '',
        company: '',
        role: '',
        isAdmin: false,
    },
    users: [],
    regions: [],
    courses: {
        data: [],
        page: null,
        total: null,
    },
    contactPersons: [],
    currencies: [],
    priceTypes: [],
    courseCategories: [],
    courseTypes: [],
    showContactPersonModal: false,
    contactPerson: {
        workingTitle: '',
        name: '',
        phone: '',
        mobilePhone: '',
        directPhoneNumber: '',
        showVcard: false,
        linkedIn: '',
        facebook: '',
        instagram: '',
        twitter: '',
        companyId: '',
        images: [],
        defaultImages: [],
        defaultImageIds: [],
        roles: ['user'],
    },
    showContactPersonDeleteModal: false,
    course: {
        additionalInformation: '',
        description: '',
        startDate: moment().unix(),
        endDate: moment().unix(),
        registrationLink: '',
        priceType: [],
        currency: [],
        categories: [],
        isStatistic: true,
        name: '',
        typeId: 1,
        contactPerson: null,
        isCommentsAllowed: true,
        showOnMaps: true,
        location: {
            regionId: null,
            municipalityId: null,
            addressId: null,
            latitude: null,
            longitude: null,
            city: null,
            postalCode: null,
            address: null,
        }
    },
    products: [],
    product: {
        name: '',
        description: '',
        isCommentsAllowed: false,
        currencyId: 1,
        priceTypeId: 3,
        images: [],
        defaultImages: [],
        defaultImageIds: [],
        files: [],
        defaultFiles: [],
        defaultFileIds: [],
        sellType: 'manufacturer',
        producer: '',
        model: '',
        referenceNumber: '',
        categoryIds: []
    },
    productTypes: [],
    showProductPreviewModal: false,
    articleTemplates: [],
    catalogs: {
        data: [],
        total: 0,
        page: 1,
        active: {
            id: 0,
            createdAt: 0,
            title: '',
            description: '',
            document: null
        }
    },

    // jobs
    jobs: {
        items: [],
        total: 0,
    },
    showJobDeleteModal: false,
    showJobPreviewModal: false,
    showPreviewModal: false,
    showResetFormModal: false,
    showModal: false,
    settings: [],
    setting: [],
    jobRegions: [],
    jobCategories: [],
    jobWorkingTimes: [],
    job: {
        jobId: null,
        isCommentsAllowed: true,
        status: 1,
        title: '',
        content: '',
        categoryId: '',
        startTime: moment().unix(),
        endTime: moment(DateHelper.getTomorrow()).unix(),
        regionId: '',
        workingTimeId: '',
        contactPersonId: null
    },
    jobsEditorState: EditorState.createEmpty(),
    articles: {
        data: [],
        total: 0,
        page: 1
    },
    article: {
        contactPersonId: 1,
        template: {
            id: 4
        },
        categories: [],
        isCommentsAllowed: true,
        publishAt: moment().unix(),
        authoredByFBG: false,
        sentOutAt: 0,
        heading: '',
        resume: '',
        images: [],
        defaultImages: [],
        defaultImageIds: [],
        files: [],
        defaultFiles: [],
        defaultFileIds: [],
        categoryIds: [],
        description: '',
        oldCategories: [],
    },
    showArticlePreviewModal: false,
    companyRegions: [],
    companyMunicipalities: [],
    company: {
        description: '',
        specialBusinessCategories: [],
        keywords: '',
        keywordsExtra: '',
        categories: [],
        images: [],
        defaultImages: [],
        defaultImageIds: [],
        imagesExtra: [],
        defaultImagesExtra: [],
        defaultImageIdsExtra: [],
        keywordsCount: '5', //@TODO Get from server
        recruiterId: '',
        countryId: '',
        regionId: '',
        municipalityId: '',
        subscriptionType: REGULAR_TYPE,
        dmogeMember: false,
        geolocationToCover: '',
        addressId: '',
        addressPreLoaded: false,
        articlesCategories: [],
        name: '',
        city: '',
        postalCode: '',
        latitude: '',
        longitude: '',
        cvr: '',
        pNumber: '',
        phoneNumber: '',
        faxNumber: '',
        email: '',
        showOnGoogleMaps: false,
        hideAddressEverywhere: false,
        showFacebookFeed: false,
        homepage: '',
        companyRegions: [],
        socials: [
            {
                "id": 1,
                "link": "",
                "socialMedia": {
                    "id": 1,
                    "name": "facebook"
                }
            },
            {
                "id": 2,
                "link": "",
                "socialMedia": {
                    "id": 2,
                    "name": "instagram"
                }
            },
            {
                "id": 3,
                "link": "",
                "socialMedia": {
                    "id": 3,
                    "name": "twitter"
                }
            },
            {
                "id": 4,
                "link": "",
                "socialMedia": {
                    "id": 4,
                    "name": "linkedin"
                }
            }
        ],
        location: {
            id: 1,
            country: {
                id: 1,
                name: "Denmark"
            },
            regionId: "",
            municipalityId: "",
            addressId: "",
            address: '',
            postalCode: "",
            city: "",
            latitude: '',
            longitude: '',
        },
        employeeCount: '',
        previewLocation: {},
        companyTaskIds: [],
        companyCoverRegions:[]
    },
    companyCoverRegions: [],
    companyCategories: [],
    companyPortals: [],
    companyKeywordsPacks: [],
    companies: {
        data: [],
        total: 0,
        page: 1
    },
    showCompanyPreviewModal: false,
    companyCategoryRestrictionModal: {
        show: false,
        companyId: null,
        count: null,
        companyCategories: [],
    },
    countries: [],
    municipalities: [],
    certificates: {
        all: [],
        selected: []
    },
    supplierCompetencies: {
        query: '', //@TODO remove
        competencies: [],
        competenciesLinear: [], //@TODO remove
        focusedInput: { //@TODO remove
            id: undefined,
            parentId: undefined
        },
        selected: [],
        selectedOne: undefined,
    },
    services: {
        data: [],
        page: 1,
        total: 0,
    },
    service: {
        categories: [],
        contactPerson : [],
        price: [],
        wanted: false,
        heading: '',
        isStatisticAllowed: false,
        isCommentsAllowed: false,
        startDate: moment().unix(),
        endDate: moment().unix(),
        images: [],
        defaultImages: [],
        defaultImageIds: [],
        files: [],
        defaultFiles: [],
        defaultFileIds: [],
        description: '',
    },
    serviceCategories: [],
    showSpinner: false,
    addressSearchResults: [],
    userAddressSearchResults: [],
    showSubmitButtonSpinner: false,

    // stored unique ids will be with spinner
    buttonsWithSpinner: [],

    machines: {
        data: [],
        total: 0,
        page: 1
    },
    machine: {
        heading: '',
        isStatisticAllowed: false,
        isCommentsAllowed: false,
        currencyId: 1,
        priceTypeId: 3,
        images: [],
        defaultImages: [],
        defaultImageIds: [],
        files: [],
        defaultFiles: [],
        defaultFileIds: [],
        sellType: 'sold',
        isUsed: 'new',
        year: 2017,
        producer: '',
        model: '',
        referenceNumber: '',
        categoryIds: [],
        description: '',
    },
    machineCategories: [],
    productCategories: [],
    businessCategories: [],
    analytics: { data: [], total: 0 },
    allAnalytics: {},
    analyticsTotal: null,
    metrics: {
        data: [],
        total: 0,
        page: 1,
        onPage: 5,
        pages: -1
    },

    portalContactPerson: {
        name: '',
        email: '',
        phone: '',
        images: [],
        defaultImages: [],
        defaultImageIds: [],
        department: null,
        portal: null,
        photo: {}
    },
    department: {},
    departments: [],
    portalContacts: [],
    companyPortalContacts: [],
    portals: [],
    sweetAlertModal: {
        show: false,
        title: '',
        text: '',
        showConfirm: true,
    },
    templateAlertModal: {
        show: false,
        title: '',
        text: '',
        canShowModal: false
    },
    analyticsDateRange: {},
    tips: [],
    tip: {
        'title': '',
        'description': '',
    },
    sortableList: {
        article: {
            column: 'id',
            asc: false,
            search: '',
        },
    },
    changelog: {
        data: [],
        total: 0,
        page: 1,
    },
    articleCategory: {
      name: '',
      description: '',
      portalId: null
    },
    articleCategories: [],
    showTokenValidationModal: false,
    vimeo: {},
    maintenanceMode: false,
    treeEditorCategories: [],
    portalsCategories: {},
    interests: {},
    treeEditorCompetencies: [],
    companyTasks: [],
    galleries: {
        data: [],
        total: 0,
        page: 1
    },
    gallery: {
        name: '',
        description: '',
    },
    galleryImage: {
        description: '',
        filePath: '',
        galleryId: null,
        originalFileName: '',
        position: 0,
        size: 0
    },
    galleryImages: [],

    parkMachineCategories: [],
    parkMachineCategory: {id: null, name: ''},

    parkMachines: {
        data: [],
        total: 0,
        page: 1,
    },

    parkMachine: {
        statusCode: 1,
        companyId: null,
        companyName: '',
        categoryId: null,
        categoryName: '',
        brand: '',
        model: '',
        quantity: 1,
        photo: null,
        createdAt: 0,
        updatedAt: 0,
    },
    rentMachineCategories: [],
    rentMachineCategory: {id: null, name: ''},
    machineRentCategory: {
        id: '',
        name: '',
    },
    rentMachines: {
        data: [],
        total: 0,
        page: 1,
    },
    rentMachine: {
        id: '',
        name: '',
        description: '',
        quantity: '',
        price: '',
        status: 1,
        image: ''
    },
    keywordsPacks: [],
    keywordsPack: {
        id: null,
        keywordsCount: '',
        description: ''
    },
}


// WEBPACK FOOTER //
// ./web/src/reducers/initialState.js